import React from "react";
import LegalPolicyRedirect from "./LegalPolicyRedirect";
export default function TermsOfService() { return <LegalPolicyRedirect policy="terms" />; }
